<template>
    <div class="Free">
        <navbar  :transparent="isTransparent" activeTo="Home"></navbar>
        <div class="free_content">
            <h1 class="Free_title font_mid">
                {{$t('user_center_order_order_details')}}
            </h1>
            <div class="free_productClass">
                <div class="pcShow">
                    <div class="free_sm_title">
                        <div class="free_img font_tip"></div>
                        <div class="free_name font_tip">{{$t('user_center_order_product')}}</div>
                        <div class="free_price font_tip">{{$t('user_center_order_price')}}</div>
                        <div class="free_num font_tip">{{$t('user_center_order_Quantity')}}</div>
                        <div class="free_total font_tip">{{$t('total')}}</div>
                    </div>
                    <div class="free_product">
                        <div class="free_img">
                            <img :src="mogos.goods_img" width="120">
                        </div>
                        <div class="free_name">
                            <p class="font_small">{{mogos.goods_name}}</p>
                            <p class="font_small" style="padding:0 10px 0 0;">{{mogos.goods_remark}}</p>
                        </div>
                        <div class="free_price font_mid">{{mogos.goods_unit}}{{mogos.market_price}}</div>
                        <div class="free_num font_mid">1</div>
                        <div class="free_total font_mid">USD ${{mogos.goods_price}}</div>
                    </div>
                </div>
                <div class="mbShow">
                    <div class="free_product">
                        <div class="free_img">
                            <img :src="mogos.goods_img" width="100">
                        </div>
                        <div class="free_name">
                            <p class="font_small">{{mogos.goods_name}}</p>
                            <p class="font_small"><span style="text-decoration:line-through;color: red;"><span style="color: #1f2d3d">{{mogos.goods_unit}}{{mogos.market_price}}</span></span>X 1</p>
                        </div>
                    </div>
                </div>
                <div class="free_productAdvantage">
                    <Row>
                        <i-col :span="24">
                            <h1 class="Free_title font_mid">{{$t('home_text_product')}}</h1>
                        </i-col>
                        <i-col :lg="12" :md="12" :sm="24" :xs="24" v-for="(list,index) in Advantage_list" :key="index" class="Advantage_wrap">
                            <div class="Advantage_img font_small">
                                <img :src="list.img" width="50">
                            </div>
                            <div class="Advantage_other">
                                <p class="font_small">{{list.title}}</p>
                                <p class="font_small">{{list.content}}</p>
                            </div>
                        </i-col>
                    </Row>
                </div>
                <div class="free_productSelect">
                    <Row>
                        <i-col :span="24">
                            <div class="free_productSelect_title">
                                <h1 class="font_mid" style="margin: 30px 0;">{{$t('free_select_title')}}</h1>
                            </div>
                        </i-col>
                        <i-col :lg="8" :md="8" :sm="24" :xs="24" v-for="(block,index) in select" :key="index">
                                <div class="Select_block" v-bind:class="{active:index == num}" @click="selectThis(index,block.goods_id)">
                                <h1 v-bind:class="{active_font:index == num}"><span style="font-size: 35px;">$</span>{{block.goods_name}}</h1>
                                <p class="font_small">{{block.innclude_content}}</p>
                                <p class="font_small">{{block.goods_remark}}</p>
                                <p class="font_small" style="color: red;" v-if="block.goods_name == 10">{{$t('free_text')}}</p>
                                <p class="font_small" style="color: red;" v-if="block.goods_name == 20">{{$t('free_text2')}}</p>
                                <div class="select_btn">
                                    <button @click="Collocation = true">{{$t('free_topup')}}</button>
                                </div>
                            </div>
                        </i-col>
                    </Row>
                </div>
            </div>
        </div>
        <!--搭配产品-->
        <modal v-model="Collocation"  class="Collocation" >
            <div slot="header"></div>
            <div class="page-content" style="text-align: center">
                <div class="Collocation_title">
                    <h2 class="font_mid">{{$t('free_select_page')}}</h2>
                </div>
                <Row class="Collocation_group">
                    <i-col :lg="8" :md="8" :sm="12" :xs="12" class="Collocation_main" v-for="(block,index) in FreeColl" :key="index">
                        <div class="Collocation_wrap">
                            <span>
                                <div class="detail-btn" @click="chooseOrder($event,block.goods_id)"></div>
                            </span>
                            <div class="Collocation_block">
                                <div class="Collocation_blockImg">
                                    <img :src="block.goods_img">
                                </div>
                                <div class="Collocation_block_part1" >
                                    <p class="font_mid">{{block.goods_name}}</p>
                                    <p class="font_small" v-html="block.goods_remark"></p>
                                </div>
                                <div class="Collocation_block_part2" @click="detail(block.goods_alias,block.goods_id)">
                                    <p class="font_mid" style="color: #0084ff">${{block.goods_price}}</p>
                                    <a class="font_small" >
                                        {{$t('learn_details')}} <Icon type="arrow-right-c"></Icon>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </i-col>
                </Row>
                <div class="Collocation_footer">
                    <div class="Collocation_pay">
                        <button @click="check">{{$t('free_btn1')}}</button>
                    </div>
                    <a class="font_small" @click="jump">{{$t('free_btn2')}}</a>
                </div>
            </div>
            <div slot="footer"></div>
        </modal>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>

<script>
    import navbar from '../../components/Common/Navbar.vue'
    import dataImage from '../../lib/dataImage'
    import Signature from '../../lib/Signature'
    import modal from '../../components/Common/Modal.vue'

    export default {
        data () {
            return {
                isTransparent:false,
                Collocation:false,
                isLogin: this.Local.get('users') !== 'undefined' && this.Local.get('users') !== null,
                select:false,
                productType:'1',
                goodsnum:'1',
                goods_img:[],
                mogos:[],
                num:1,
                Advantage_list: [
                    {
                        img:require('../../assets/home/new_home/free_1.png'),
                        title:this.$t('free_title1'),
                        content: this.$t('free_content1')
                    },
                    {
                        img:require('../../assets/home/new_home/free_2.png'),
                        title:this.$t('free_title2'),
                        content: this.$t('free_content2')
                    },
                    {
                        img:require('../../assets/home/new_home/free_3.png'),
                        title:this.$t('free_title3'),
                        content:this.$t('free_content3')
                    },
                    {
                        img:require('../../assets/home/new_home/free_4.png'),
                        title:this.$t('free_title4'),
                        content: this.$t('free_content4')
                    },
                    {
                        img:require('../../assets/home/new_home/free_5.png'),
                        title:this.$t('free_title5'),
                        content: this.$t('free_content5')
                    },
                    {
                        img:require('../../assets/home/new_home/free_6.png'),
                        title:this.$t('free_title6'),
                        content: this.$t('free_content6')
                    },
                ],
                select:[],
                FreeColl: []
            }
        },
        components:{
            navbar,modal
        },
        methods:{
            detail (good_name,id) {
                this.$router.push({
                    path: '/product/' + good_name,
                    query: {
                        id: id
                    }
                })
            },
            //付款
            check () {
                if(!this.isLogin){
                    this.$Message.info(this.$t('user_message_please_login'))
                    this.$router.push(
                        {
                            name:'Login'
                        }
                    )
                    return false
                }
                let data = {}
                const module = 'index.php/mogos/preview'
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.signature= Signature.create(module, data.sub_time)
                data.goods_id = this.productType
                data.number = this.goodsnum
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        if (parseInt(resp.data.code) === 2000) {
                            this.Collocation = false
                            this.$router.push({
                                name: 'Settlement',
                                query: {
                                    goods_id: this.Local.get('productType') + ','+this.Local.get('select_id'),
                                    number: this.Local.get('goodsnum')+','+ 1,
                                    type: '9'
                                }
                            })
                            //清空数据
                            this.Local.set('productType','1')
                            this.Local.set('goodsnum','1')
                        }else{
                            this.$Message.info(resp.data.msg)
                        }
                    }.bind(this))
            },
            //跳过
            jump () {
                    if(!this.isLogin){
                        this.$Message.info(this.$t('user_message_please_login'))
                        this.$router.push(
                            {
                                name:'Login'
                            }
                        )
                        return false
                    }
                    let data = {}
                    const module = 'index.php/mogos/preview'
                    data.user_id = this.Local.getUserId()
                    data.token = this.Local.getUserToken()
                    data.lang = this.$i18n.locale
                    data.signature= Signature.create(module, data.sub_time)
                    data.goods_id = this.productType
                    data.number = this.goodsnum
                    this.$http.post(process.env.BASEURL + module, data)
                        .then(function (resp) {
                            if (parseInt(resp.data.code) === 2000) {
                                this.Collocation = false
                                this.$router.push({
                                    name: 'Settlement',
                                    query: {
                                        goods_id: '1,'+ this.Local.get('select_id'),
                                        number: '1,1',
                                        type: '9'
                                    }
                                })
                            }else{
                                this.$Message.info(resp.data.msg)
                            }
                        }.bind(this))
            },
            //单选套餐
            selectThis (type,id){
                this.num = type
                this.Local.set('select_id', id)
            },
            //多选产品
            chooseOrder:function (e,id){
                if (e.target.className.indexOf("detail-selected") == -1) {
                    e.target.className = "detail-btn detail-selected"; //切换按钮样式
                    this.productType += ','+ id
                    this.goodsnum += ','+1
                    this.Local.set('productType', this.productType)
                    this.Local.set('goodsnum', this.goodsnum)
                } else {
                    e.target.className = "detail-btn";//切换按钮样式
                    this.productType = this.productType.split(","+id).join("");
                    this.goodsnum =this.goodsnum.substring(0,this.goodsnum.length-2)
                    this.Local.set('productType', this.productType)
                    this.Local.set('goodsnum', this.goodsnum)
                }
            },
            //获取领取详情
            GetFree () {
                let module = 'index.php/mogos/package'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                }).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.mogos = resp.data.data.mogos[0]
                        this.select = resp.data.data.goods_list
                        console.log(this.select)
                    }
                }.bind(this))
            },
            //产品详情
            productDetail() {
                let module = 'index.php/index/goods/goodslist'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                data.free = 1
                data.type = 1
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                }).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.FreeColl = resp.data.data.goods_list
                    }
                }.bind(this))

            }
        },
        created () {
            //获取领取详情
            this.GetFree ()

            //产品详情
            this.productDetail()

        }
    }
</script>
<style lang="scss" >
    @import "../../scss/_freemogos.scss";
    .Free{
        .modal .modal-header .ivu-icon-close-round{
            display: none !important;
        }
        .modal .modal-wrap.modal-middle{
            width: 95% !important;
            max-width: 1000px !important;
            top:5% !important;
        }
        .modal .modal-body{
            padding:2% 5% !important;
        }
    }

    @media (max-height: 760px) and (min-width: 768px){
        .modal .modal-wrap.modal-middle{
            height: 90% !important;
            overflow-y: scroll;
        }
        .modal-body{
            position: relative !important;
            margin-bottom: 50px !important;
        }
        .Collocation_footer{
            position: fixed;
            bottom: 6%;
            left: 16%;
            background: #ffffff;
            width: 72%;

        }
    }


</style>



// WEBPACK FOOTER //
// Free.vue?6fdb8f34